import apiHeader from '@/helpers/apiHeader';

const plannerGroupService = {
  list(page, params) {
    return apiHeader.get('planner-groups?page=' + page, { params });
  },
  get(id) {
    return apiHeader.get('planner-groups/' + id);
  },
};

export default plannerGroupService;
